module.exports = __webpack_public_path__ + "img/AM_Print_CI_147937286_1_2.754f5927.png";